export const menuItens = ['dashboard', 'olts', 'mapa']